import { render, staticRenderFns } from "./classifiedManagement.vue?vue&type=template&id=499c3d90&scoped=true&"
import script from "./classifiedManagement.vue?vue&type=script&lang=js&"
export * from "./classifiedManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499c3d90",
  null
  
)

export default component.exports